import { MultiColumnComboBox } from '@progress/kendo-react-dropdowns'
import { FieldRenderProps } from '@progress/kendo-react-form';
import React, { FunctionComponent, useRef } from 'react'
import {
    Label,
    Error,
} from "@progress/kendo-react-labels";
import { ProjectApi } from '../../redux/api/ProjectApi';
import { IWorkstream } from '../../types/Gameplan/IWorkstream';

const WorkstreamList: FunctionComponent<FieldRenderProps> = props => {
    const {
        validationMessage,
        label,
        id,
        disabled,
        optional,
        projectId,
        onChange,
    } = props;

    const { data: workstreams, isLoading } = ProjectApi.useGetWorkstreamsQuery(projectId);
    const prettyWorkStreams = workstreams?.map(w => { return { ...w, StartDt: new Date(w.StartDt)?.toLocaleDateString(), EndDt: new Date(w.EndDt)?.toLocaleDateString() } })
    const isValid = !validationMessage;
    const showValidationMessage = validationMessage;
    const errorId = showValidationMessage ? `${id}_error` : "";
    const wrapper = useRef(null);

    return (
        <div ref={wrapper}>
            <Label
                editorId={id}
                editorValid={isValid}
                editorDisabled={disabled}
                optional={optional}
            >
                {label} {showValidationMessage && (<Error id={errorId}>{validationMessage}</Error>)}
            </Label>

            <div className={"k-form-field-wrap"} >
                {/* popupSettings={{ appendTo: wrapper?.current }} */}
                <MultiColumnComboBox valid={isValid} size='small' value={props.value?.Workstream_Name}
                    columns={[
                        { field: 'Workstream_Name', header: 'Workstream' },
                        { field: 'StartDt', header: 'Start', width: '120px' },
                        { field: 'EndDt', header: 'End', width: '120px' }
                    ]} onChange={onChange} data={prettyWorkStreams} loading={isLoading} required={props.isRequired} dataItemKey='Workstream_Id' />
            </div>
        </div>
    )
}


export default WorkstreamList;